import {toastr} from "react-redux-toastr"

export const success = (cfg = {}) => {
  const {title = "Success", message = "", ...options} = cfg
  toastr.success(title, message, options)
}

export const info = (cfg = {}) => {
  const {title = "Note", message = "", ...options} = cfg
  toastr.info(title, message, options)
}

export const warning = (cfg = {}) => {
  const {title = "Warning", message = "", ...options} = cfg
  toastr.info(title, message, options)
}

export const error = (cfg = {}) => {
  const {title = "Error", message = "", ...options} = cfg
  toastr.error(title, message, options)
}

export default {success, info, warning, error}
